import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, AlertTriangleIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function EasterAnnouncementPopup() {
  const [open, setOpen] = useState(true);
  const {
    language
  } = useLanguage();
  const isEs = language === 'ES';
  return <AnimatePresence data-id="element-2154">
      {open && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(false)} data-id="element-2155">
          <motion.div initial={{
        opacity: 0,
        scale: 0.92,
        y: 24
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.92,
        y: 24
      }} transition={{
        duration: 0.35,
        ease: [0.16, 1, 0.3, 1]
      }} className="bg-white rounded-2xl shadow-2xl max-w-lg w-full overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-2156">
            {/* Top accent bar */}
            <div className="h-2 bg-gradient-to-r from-haa-blue via-haa-skyblue to-haa-midblue" data-id="element-2157" />

            {/* Header */}
            <div className="flex items-start justify-between px-6 pt-5 pb-0" data-id="element-2158">
              <div className="flex items-center gap-3" data-id="element-2159">
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-md flex-shrink-0" data-id="element-2160">
                  <AlertTriangleIcon className="w-6 h-6 text-white" data-id="element-2161" />
                </div>
                <div data-id="element-2162">
                  <p className="font-nunito text-amber-600 text-xs uppercase tracking-[0.2em] font-bold" data-id="element-2163">
                    {isEs ? 'Anuncio Especial' : 'Special Announcement'}
                  </p>
                  <h2 className="font-bebas text-2xl sm:text-3xl text-haa-navy tracking-wider leading-tight mt-0.5" data-id="element-2164">
                    {isEs ? 'Cierre de Consulados' : 'Consulate Closure'}
                  </h2>
                </div>
              </div>
              <button onClick={() => setOpen(false)} className="p-2 rounded-lg hover:bg-gray-100 transition-colors text-gray-400 hover:text-gray-600 flex-shrink-0 -mr-1 -mt-1" aria-label="Close" data-id="element-2165">
                <XIcon className="w-5 h-5" data-id="element-2166" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-5 space-y-4" data-id="element-2167">
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4" data-id="element-2168">
                <p className="font-nunito text-gray-800 text-sm sm:text-base leading-relaxed" data-id="element-2169">
                  {isEs ? 'Todos los consulados hondureños en los Estados Unidos estarán cerrados el ' : 'All Honduran consulates in the United States will be closed on '}
                  <strong className="text-haa-navy" data-id="element-2170">
                    {isEs ? 'jueves 2 de abril y viernes 3 de abril de 2026' : 'Thursday, April 2 and Friday, April 3, 2026'}
                  </strong>
                  {isEs ? ' debido a la celebración de Semana Santa.' : ' in observance of the Easter holiday.'}
                </p>
              </div>

              <div className="flex items-start gap-3 bg-blue-50 border border-blue-100 rounded-xl p-4" data-id="element-2171">
                <PhoneIcon className="w-5 h-5 text-haa-blue flex-shrink-0 mt-0.5" data-id="element-2172" />
                <p className="font-nunito text-gray-700 text-sm leading-relaxed" data-id="element-2173">
                  {isEs ? 'Si ya tiene una cita programada para esas fechas, por favor llame a su consulado para reprogramar.' : 'If you have an appointment already scheduled for those dates, please call your consulate to reschedule.'}
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-6 pb-5" data-id="element-2174">
              <button onClick={() => setOpen(false)} className="w-full py-3 bg-haa-navy hover:bg-haa-blue text-white font-nunito font-bold text-sm rounded-xl transition-colors shadow-md" data-id="element-2175">
                {isEs ? 'Entendido' : 'Got It'}
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}